module.exports = __webpack_public_path__ + "static/media/29830007-QgR0wSgs.944daa4a.JPG";